module.exports = __webpack_public_path__ + "img/appmalfsdk-demo-bg.deea130.png";